export const filterReturnPortalsBySearch = (search, returnPortals = []) => {
  if (!search) return returnPortals

  return returnPortals.filter(
    portal =>
      portal.name.toLowerCase().includes(search.toLowerCase()) ||
      portal.slug.toLowerCase().includes(search.toLowerCase())
  )
}
